import { 
  statusDoctorStart,
  statusDoctorSuccess,
  statusDoctorFailure 
} from "./doctorSlice";

import { get, post, put, remove } from "../../requestMethods"
import { Dispatch } from "react";

export const getDoctorsApi = () => async (dispatch: Dispatch<any>) => {
  try {
    dispatch(statusDoctorStart())
    const response = await get(`doctor`);
    const resData = response.data.success
    if(resData) {
      dispatch(statusDoctorSuccess(resData))
      return true
    }
  } catch (err: any) {
    const errData = err.response.data
    if(errData && err.response.status === 300) {
      const formErrors = errData.formErrors ? errData.formErrors : [errData] 
      dispatch(statusDoctorFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusDoctorFailure(errData))
      return [errData]
    }
  }
}

export const AddDoctorApi = (data: any) => async (dispatch: Dispatch<any>) => {
  try {
    dispatch(statusDoctorStart())
    const response = await post(`doctor`, data);
    const resData = response.data.success
    if(resData) {
      dispatch(statusDoctorSuccess(resData))
      return true
    }
  } catch (err: any) {
    const errData = err.response.data
    if(errData && err.response.status === 300) {
      const formErrors = errData.formErrors ? errData.formErrors : [errData] 
      dispatch(statusDoctorFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusDoctorFailure(errData))
      return [errData]
    }
  }
}

export const EditDoctorApi = (doctorId: string, data: any) => async (dispatch: Dispatch<any>) => {
  try {
    dispatch(statusDoctorStart())
    const response = await put(`doctor/${doctorId}`, data);
    const resData = response.data.success
    if(resData) {
      dispatch(statusDoctorSuccess(resData))
      return true
    }
  } catch (err: any) {
    const errData = err.response.data
    if(errData && err.response.status === 300) {
      const formErrors = errData.formErrors ? errData.formErrors : [errData] 
      dispatch(statusDoctorFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusDoctorFailure(errData))
      return [errData]
    }
  }
}

export const DeleteDoctorApi = (doctorId: string) => async (dispatch: Dispatch<any>) => {
  try {
    dispatch(statusDoctorStart())
    const response = await remove(`doctor/${doctorId}`);
    const resData = response.data.success
    if(resData) {
      dispatch(statusDoctorSuccess(resData))
      return true
    }
  } catch (err: any) {
    const errData = err.response.data
    if(errData && err.response.status === 300) {
      const formErrors = errData.formErrors ? errData.formErrors : [errData] 
      dispatch(statusDoctorFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusDoctorFailure(errData))
      return [errData]
    }
  }
}


export const DisappearedDoctorApi = (doctorId: string, data: any) => async (dispatch: Dispatch<any>) => {
  try {
    dispatch(statusDoctorStart())
    const response = await put(`doctor/disappear/${doctorId}`, data);
    const resData = response.data.success
    if(resData) {
      dispatch(statusDoctorSuccess(resData))
      return true
    }
  } catch (err: any) {
    const errData = err.response.data
    if(errData && err.response.status === 300) {
      const formErrors = errData.formErrors ? errData.formErrors : [errData] 
      dispatch(statusDoctorFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusDoctorFailure(errData))
      return [errData]
    }
  }
}

export const clearDoctorApi = async (dispatch: Dispatch<any>) => {
  dispatch(statusDoctorSuccess([]))
}
